
interface ErrorStateProps {
  message?: string;
}

/**
 * Error state for article content
 */
const ErrorState = ({ message }: ErrorStateProps) => {
  return (
    <div className="text-muted-foreground italic space-y-4">
      <p>No content available for this article.</p>
      {message && <p>{message}</p>}
      <p>Please check the console for debugging information or try refreshing the page.</p>
    </div>
  );
};

export default ErrorState;
